/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CrudJournalEventBaseComponent from "core/components/forc/abstract/crud-journal-event-based-component";
import journalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import DiabguideRecommendation from "core/models/diabguide-recommendation";
import DiabguideRecommendationComputedJournalEvent from "core/models/diabguide-recommendation-computed-journal-event";
export default class DiabguideEditionFormComponent extends CrudJournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "retrieveJournalEvent", journalEventRetrievalStrategies.sourceJournalEvent);
  }
  get datas() {
    return this.changeset.data["data"];
  }
}
_defineProperty(DiabguideEditionFormComponent, "forcDisplayName", void 0);
_defineProperty(DiabguideEditionFormComponent, "fullComponentId", void 0);
_defineProperty(DiabguideEditionFormComponent, "journalEventClass", DiabguideRecommendationComputedJournalEvent);